import React from 'react';

const Ukraine = (props) => (
<img src="https://flagsapi.com/UA/flat/64.png" width={40} height={'auto'} />
);

export default Ukraine;



